export default "__VITE_ASSET__CRkkT_R9__"